<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Run Backup Task</p>
      <button class="delete" aria-label="close" @click="$emit('close')"></button>
    </header>
    <section class="modal-card-body">
      <label class="label">Days</label>
      <div class="select">
        <select v-model="number_of_days">
          <option v-for="n in 5">{{n}}</option>
        </select>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button flex-pulled-right" @click="$emit('close')">Close</button>
      <button class="button flex-pulled-right" @click="ok()">Ok</button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'SyncModal',
  props: ['callback'],
  data () {
    return {
      number_of_days: 1
    }
  },
  methods: {
    ok () {
      this.callback(this.number_of_days)
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label { display: inline-block; width: 150px; text-align: left; }
</style>
